import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { setModal } from 'modules/_shared/redux/modalActions';
import { useGetTransactionsSectionPermissions } from 'modules/transactions/hooks/useGetTransactionsSectionPermissions';
import { UpdateOperationModlaProvider } from 'modules/_shared/components/Modals/UpdateOperationModal/context/UpdateOperationModalContext';
import EditButton from 'modules/_shared/components/Buttons/EditButton';
import UpdateOperation from 'modules/_shared/components/Modals/UpdateOperationModal';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { operationsWithoutNotarialRegistrationSection } from '../constants/operationsWithoutNotarialRegistrationSection';

const NotarialRegistrationSection: FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { data } = useOperationDetailsPage();
  const { isReadOnly } = useGetTransactionsSectionPermissions().data;

  const notarialRegistration = data.operation?.notarialRegistration;
  const notaryName = notarialRegistration?.notaryName || '-';
  const protocolNr = notarialRegistration?.protocolNr || '-';
  const notaryCity = notarialRegistration?.notaryCity || '-';
  const hasNotarialRegistration =
    !operationsWithoutNotarialRegistrationSection.includes(
      data.operation?.operationType || ''
    );

  return (
    <div className="invoice-contact col-md-5 offset-md-1 mt-4 mt-md-0">
      {hasNotarialRegistration && (
        <>
          <span className="overline-title">
            {t('NotarialRegistration')}
            <EditButton
              className="ml-1 pb-1"
              action={() =>
                dispatch(
                  dispatch(
                    setModal(
                      <UpdateOperationModlaProvider
                        operation={data.operation}
                        hasNotarialRegistration={hasNotarialRegistration}
                      >
                        <UpdateOperation />
                      </UpdateOperationModlaProvider>
                    )
                  )
                )
              }
              disabled={isReadOnly}
            />
          </span>

          <ul className="list-plain mt-2">
            <li>
              <em className="icon ni ni-user-list" />
              <span>{notaryName}</span>
            </li>
            <li>
              <em className="icon ni ni-article" />
              <span>{protocolNr}</span>
            </li>
            <li>
              <em className="icon ni ni-map-pin" />
              <span>{notaryCity}</span>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default NotarialRegistrationSection;
